import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import Header from './Header'

const mapStateToProps = state => {
  return {
    user: state.user.user,
    brand: getFromSettings(state, 'brand', {}),
  }
}

export default connect(mapStateToProps)(Header)
